import module from 'empresa/module.js'
import template from './template.html'
import moment from 'moment'

export class EmpresaReportesIsnComponent {
  empresaId = null
  fechaInicial = null
  fechaFinal = null
  generando = false

  constructor ($location) {
    this.$location = $location
  }

  $onChanges (changes) {
    if (changes.fechaInicial)
      this.fechaInicial = moment(this.fechaInicial).startOf('month').toDate()

    if (changes.fechaFinal)
      this.fechaFinal = moment(this.fechaFinal).startOf('month').toDate()
  }

  buscar () {
    let fecha_inicial = moment(this.fechaInicial).startOf('month'),
      fecha_final = moment(this.fechaFinal).endOf('month')

    this.$location.search({
      fecha_inicial: fecha_inicial.format('YYYY-MM-DD'),
      fecha_final: fecha_final.format('YYYY-MM-DD'),
    })

    this.generando = true
  }
}

module.component('empresaReportesIsn', {
  controller: EmpresaReportesIsnComponent,
  template,
  bindings: {
    empresaId: '<',
    fechaInicial: '<',
    fechaFinal: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/reportes/isn/component.js